var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-View"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "View",
    clipPath: "url(#clip-View)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_eye",
    transform: "translate(-1.541 -2.041)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Bounds",
    d: "M0,0H22.072V22.072H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M8.528,11.037A9.437,9.437,0,0,1,3.313,9.489,8.8,8.8,0,0,1,0,5.518a8.8,8.8,0,0,1,3.313-3.97,9.558,9.558,0,0,1,10.429,0,8.8,8.8,0,0,1,3.313,3.97,8.8,8.8,0,0,1-3.313,3.971A9.439,9.439,0,0,1,8.528,11.037Zm0-7.726A2.271,2.271,0,0,0,6.2,5.518,2.271,2.271,0,0,0,8.528,7.726a2.272,2.272,0,0,0,2.326-2.208A2.271,2.271,0,0,0,8.528,3.311Z",
    transform: "translate(3.01 6.02)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/View.858ed8d7fa855f4f769d5cb612c910bb.svg";
export { ForwardRef as ReactComponent };